<template>
    <div class="w-100 pv3 ph3 flex hover-bg-near-white pointer items-center">
        <img :style="getDimensions" class="flex-none ba b--light-gray" :src="tool.img">
        <div class="ph2 ph3-ns flex-auto">
            <div><h6>{{ tool.title }}</h6></div>
            <slot name="content"></slot>
        </div>
        <slot name="icon"></slot>
    </div>
</template>

<script>
export default {
    props: {
        tool: {
            type: Object,
            required: true
        },
        imageLarge: {
            type: Array
        }
    },
    computed: {
        largeImage() {
            var match = false;

            this.imageLarge.forEach(element => {
                if (this.$mq === element) {
                    match = true;
                }
            });

            return match;
        },
        getDimensions() {
            return this.largeImage
                ? 'width: 108px; height: 108px'
                : 'width: 76px; height: 76px;';
        }
    }
};
</script>
